/**
 * Get started details about shoppable/ custom collection filter
 * 1. @param {string} -  fetchUrl, selectedTags, sortByValue
 * fetchUrl: (URL which use in fetch function update based on select filter value), 
 * selectedTags: (store all selected tag value which store when click filter), 
 * sortByValue: (store all selected sortby/sorting value which store when click sortby), 
 * giridView: (show product type list or grid)
 * @param {number} - currentPage
 * currentPage: (store selected page number which store when page load), 
 */
if(document.querySelector('.collection-shoppable')){
    window.Shoppable_collection = {
        collectionFilters: document.querySelector('collection-filters'),
        fetchUrl: ``,
        selectedTags: null,
        sortByValue: `manual`,
        currentPage: 1,
        giridView: 'grid',
        collectionHandle: document.body.getAttribute('id'),

        // function run when window load and all click event write in this function
        init(){

            // function for get selected tag when click filter
            document.querySelectorAll('[data-tagslist]').forEach((tagInput) => {
                tagInput.addEventListener('click', (tagInputEL) => {
                    this.selectedTags = null;
                    if(!tagInputEL.target.classList.contains('form-check-label')) {
                        this.collectionFilters.querySelectorAll('input[data-tagsList-input]:checked').forEach((option) => {
                            if (this.selectedTags != null) this.selectedTags += `+${option.value}`
                            else this.selectedTags = `${option.value}`
                        });
                        localStorage.setItem(`${this.collectionHandle}_filters`, (this.selectedTags == null ? '' :  this.selectedTags));
                        this.FetchData();
                    }
                })
            });

            // function for get sortByValue when click sortby value
            document.querySelectorAll('[custom-data-sortby-li] label').forEach((list) => {
                list.addEventListener('click', (listEl) => {
                    if (listEl) {
                        setTimeout( async() => {
                            this.sortByValue = document.querySelector('[custom-data-sortby-UL] li.selected').getAttribute('data-value');
                            localStorage.setItem(`${this.collectionHandle}_sorting`, (this.sortByValue == null ? '' : this.sortByValue));
                            this.FetchData();
                        }, 500);
                       
                    }
                })
            });

            // function for mobile apply filter
            if(window.innerWidth < 767) {
                document.querySelector('[ data-applyfilters]').addEventListener('click', (listEl) => {
                    listEl.preventDefault();
                    document.querySelector('.collection-filters-close').dispatchEvent(new Event('click'));
                });
            }

             // function for manage grid view for product show
            document.querySelectorAll('.snize-view-mode-icon').forEach((viewType) => {
                viewType.addEventListener('click', (viewTypeEL) => {
                    viewTypeEL.preventDefault();
                    document.querySelectorAll('.snize-view-mode-icon').forEach((viewType) =>  viewType.classList.remove('active') );
                    this.viewTypeShow = viewTypeEL.currentTarget.getAttribute('view_type');
                    viewTypeEL.currentTarget.classList.add('active');
                    if (this.viewTypeShow == 'list') {
                        document.querySelectorAll('.product-list-div').forEach((productListDiv) => {
                            productListDiv.classList.add('grid');
                        });
                    }
                    else {
                        document.querySelectorAll('.product-list-div').forEach((productListDiv) => {
                            productListDiv.classList.remove('grid');
                        });
                    }
                });
            });

            // function for get page reload when click on pagination when click sortby value
            document.querySelectorAll('[data-pagination] a').forEach((paginationLink) => {
                paginationLink.addEventListener('click', (paginationLinkEl) => {
                    paginationLinkEl.preventDefault();
                    let paginationHref = paginationLinkEl.currentTarget.href;
                    if (paginationHref) window.location.href = paginationHref; 
                })
            }); 

            var filterValues = localStorage.getItem(`${this.collectionHandle}_filters`);
            var sortingValues = localStorage.getItem(`${this.collectionHandle}_sorting`);
            if ((filterValues != null || sortingValues != null) && 
                (filterValues != "null" || sortingValues != "null") && 
                (filterValues != "" || sortingValues != "")) { 
                this.selectedTags = filterValues; 
                this.sortByValue = sortingValues; 
                if (this.selectedTags != "" && this.selectedTags != null) {
                    var filtersDataArray = this.selectedTags.split('+');
                    filtersDataArray.map(item => {
                        document.querySelector(`[data-tagslist-input][value="${item}"]`).checked = true;
                    })   
                }
                if (this.sortByValue != "") {
                    document.querySelectorAll(`[value="${this.sortByValue}"]`).forEach(sortValue => {
                        sortValue.checked = true;
                    })
                    var sortLabel = document.querySelector(`[data-value="${this.sortByValue}"] label`)?.innerText;
                    document.querySelector('custom-select.sortby-dropdown .option_txt') != null && (document.querySelector('custom-select.sortby-dropdown .option_txt').innerText = sortLabel);
                }
                this.FetchData();
            }
        },

        // function for fetch data and update the products data
        async FetchData() {
            const urlParams = new URLSearchParams(window.location.search);
            const pageNumber = urlParams.get('page');
            if (pageNumber != null) this.currentPage = pageNumber
            document.getElementById('collection-product-grid').classList.add('d-none');
            
            document.querySelectorAll('products-list').forEach(async (listProducts) => {
                
                let collectionhandle = listProducts.getAttribute('collection-handle');
                try { 
                    
                if (this.selectedTags != null && this.selectedTags != "" && this.selectedTags != "null") {
                    this.fetchUrl = `/collections/${collectionhandle}${this.selectedTags != null ? ('/' + this.selectedTags) : ''}?sort_by=${this.sortByValue}&page=${this.currentPage}&view=shoppable-products`;
                }
                else {
                    this.fetchUrl = `/collections/${collectionhandle}?sort_by=${this.sortByValue}&page=${this.currentPage}&view=shoppable-products`;
                }

               await fetch(this.fetchUrl, {
                        method: 'GET'
                }).then((response) => response.text())
                .then((response) => {
                    let productsHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('shopaable-products');
                    if (productsHTML) {
                        document.querySelector(`[collection-handle="${collectionhandle}"]`).innerHTML = ``;
                        document.querySelector(`[collection-handle="${collectionhandle}"]`).innerHTML = productsHTML.innerHTML;
                        document.getElementById('collection-product-grid').classList.remove('d-none');
                        if (this.viewTypeShow == 'list') {
                            document.querySelectorAll('.product-list-div').forEach((productListDiv) => {
                                productListDiv.classList.add('grid');
                            });
                        }
                    }
                });
                
                } catch(e) {
                    console.error(e);
                    Rollbar.error("Error when fetch data for collection"+e);
                };
                
            });
        }
    
    }
    window.Shoppable_collection.init();
}
